import React from 'react';
import PropTypes from 'prop-types';
import Form from 'react-form-controlled';
import {FormattedMessage} from 'react-intl';
import MessageDefinitions from './MessageDefinitions';
import {LocationShape} from '@ignitesales/neuro-application/src/shapes';

const AppointmentInformation = ({success, selectedLocation, selectedTime}) => {

  const dayFormat = {weekday: 'long', month: 'long', year: 'numeric', day: 'numeric'};
  const timeFormat = {hour: 'numeric', minute: 'numeric'};

  const message =
    success
      ?
      <div className="appointmentInformation">
        <h1><FormattedMessage {...MessageDefinitions.appointmentThanksTitle} /></h1>
        <h5><FormattedMessage {...MessageDefinitions.appointmentThanksText} /></h5>
        <div className="appointmentInfo__details">
          <h2 className="day">{selectedTime.start.toLocaleDateString('en-US', dayFormat)}</h2>
          <h2 className="time">{selectedTime.start.toLocaleTimeString('en-US', timeFormat)}</h2>
          <h3 className="locationName">{selectedLocation.name}</h3>
          <h3 className="address">{selectedLocation.address}</h3>
          <h3 className="cityState">{selectedLocation.city}, {selectedLocation.state} {selectedLocation.postalCode}</h3>
        </div>
      </div>
      :
      <div><FormattedMessage {...MessageDefinitions.appointmentFailed} /></div>;

  return (
    <Form className="contactMe__form">
      <div className="form-body">
        {message}
      </div>
    </Form>
  );
};

AppointmentInformation.propTypes = {
  selectedLocation: LocationShape,
  selectedTime: PropTypes.object,
  success: PropTypes.bool
};

export default AppointmentInformation;

